import React, { useCallback } from 'react';
import { Link } from 'react-scroll';
import * as c from '../../ts/const';
import ImgPicture from './img-picture';
import { sendGtag } from '../../ts/modules/sendgtag';
const HeaderSliderItem = ({ saleItem }) => {
    const handleClick = useCallback(() => {
        const eventPrams = {
            event_action: 'TOP',
            event_category: c.EVENT_CATEGORY,
            event_label: `TOP]${saleItem.name}`
        };
        sendGtag(eventPrams, c.IS_DEV);
    }, [
        saleItem
    ]);
    return (React.createElement(Link, { to: `_${saleItem.image_name}`, smooth: true, duration: 300, onClick: handleClick },
        React.createElement(ImgPicture, { fileName: `./assets/img/sale-item/${saleItem.image_name}`, alt: saleItem.name, ext: 'jpg' })));
};
export default HeaderSliderItem;
